var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meetings",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8955",
    "data-name": "Rectangle 8955",
    width: 15,
    height: 15,
    transform: "translate(1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16266",
    "data-name": "Path 16266",
    d: "M14,8.455V5.375A1.446,1.446,0,0,0,12.5,4h-9A1.446,1.446,0,0,0,2,5.375v8.25A1.446,1.446,0,0,0,3.5,15h9A1.446,1.446,0,0,0,14,13.625v-3.08L16.362,12.7A.378.378,0,0,0,17,12.456V6.544a.378.378,0,0,0-.638-.241ZM8,6.75A1.446,1.446,0,0,1,9.5,8.125,1.446,1.446,0,0,1,8,9.5,1.446,1.446,0,0,1,6.5,8.125,1.446,1.446,0,0,1,8,6.75Zm3,5.5H5v-.392a1.385,1.385,0,0,1,.915-1.272,5.65,5.65,0,0,1,4.17,0A1.385,1.385,0,0,1,11,11.858Z",
    transform: "translate(-1 -2)",
    fill: "#7f8fa4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.211d04e69b6ed0f041cbd1d753cc7178.svg";
export { ForwardRef as ReactComponent };